<script setup lang="ts">
import type { IMenuItem } from "@/components/legacy/Menu/menu.interface"
import { ref, toValue } from "vue"
import { AppLink, Icon } from "@/components/ui"

withDefaults(
  defineProps<{
    item: IMenuItem
    as?: string
  }>(),
  { as: "li" },
)

const emit = defineEmits<{
  navigate: []
}>()

const isOpen = ref(false)

function onNavigate() {
  emit("navigate")
}
</script>

<template>
  <component
    :is="as" v-if="!toValue(item.isHidden)"
    class="my-4 whitespace-nowrap text-2xl font-montserrat font-bold"
  >
    <div class="flex flex-col justify-center">
      <button
        v-if="item.children?.length"
        class="flex gap-2 no-underline text-start hover:underline focus:underline" @click="isOpen = !isOpen"
      >
        {{ item.label }}
        <Icon
          v-if="item.children?.length" icon="CircleChevronDown" class="transition ease-in"
          :class="{ '-rotate-90': !isOpen }"
        />
      </button>
      <button
        v-else-if="item.onClick" class="text-start no-underline hover:underline focus:underline"
        @click="item.onClick"
      >
        {{ item.label }}
      </button>
      <AppLink
        v-else-if="item.to" class="no-underline hover:underline focus:underline" :to="item.to"
        @click="onNavigate"
      >
        {{ item.label }}
      </AppLink>
      <a
        v-else-if="item.href" class="no-underline hover:underline focus:underline" :href="item.href"
        target="_blank" rel="noopener noreferrer"
      >
        {{ item.label }}
      </a>
      <div v-if="isOpen">
        <MobileMenuItem
          v-for="child in item.children" :key="child.key" :item="child" class="ml-4"
          @navigate="onNavigate"
        />
      </div>
    </div>
  </component>
</template>
